export default "<app-deliverytimes></app-deliverytimes>\n"